import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment"

export type SarsModel = {
  createdDate: string;
  modifiedDate: string;
  id: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  referenceNumber: string;
  caseTitle: string;
  status: number | null ;
  dateReceived: string;
  dateResponseDue: string;
  caseLeadUPN: string | null;
  caseLeadDisplayName: string | null;
  identificationRequired: number ;
  dateIdRequested: string | null;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string |null;
  telephone: string | null;
  line1: string | null;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  postcode: string | null;
  countryId: number | null;
  requestType: number[];
  requestDetail: string | null;
  caseSummary: string | null;
  sourceId: number | null;
  categoryId: number | null;
  sarsAttachments: Attachment[];
  files: File[];
  pausedTime: number;
};

export const fromApiModel = (model: Model): SarsModel => {
  return {
  createdDate: model.createdDate,
  modifiedDate: model.modifiedDate,
  id: model.id,
  createdByUpn: model.createdByUpn, 
  createdByDisplayName: model.createdByDisplayName,
  modifiedByUpn: model.modifiedByUpn,
  modifiedByDisplayName: model.modifiedByDisplayName,
  referenceNumber: model.referenceNumber,
  caseTitle: model.caseTitle,
  status: model.status,
  dateReceived: model.dateReceived,
  dateResponseDue: model.dateResponseDue,
  caseLeadUPN: model.caseLeadUPN,
  caseLeadDisplayName: model.caseLeadDisplayName,
  identificationRequired: model.identificationRequired,
  dateIdRequested: model.dateIdRequested,
  firstName: model.firstName,
  middleName: model.middleName,
  lastName: model.lastName,
  email: model.email,
  telephone: model.telephone,
  line1: model.line1,
  line2: model.line2,
  line3: model.line3,
  line4: model.line4,
  postcode: model.postcode,
  countryId: model.countryId,
  requestType: model.requestType,
  requestDetail: model.requestDetail,
  caseSummary: model.caseSummary,
  sourceId: model.sourceId,
  categoryId: model.categoryId,
  sarsAttachments: model.sarsAttachments,
  files: model.files,
  pausedTime: model.pausedTime
  };
};

export const toApiModel = (item: SarsModel): Model => {
  return {
    ...item,
  } as Model;
};

export enum SarsStatus {

    New = 0,
    Open = 1,
    Paused = 2,
    Closed = 3,
    Rejected = 4,
    "Internal Review" = 5,
    ICO = 6,
}